import axios from "axios";
import { rollbarConfig } from "lib/rollbarConfig";
import Rollbar from "rollbar";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const contentful = require("contentful");

export const apiFlickClient = axios.create({
  baseURL: process.env.REACT_APP_FLICK_API_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
  },
});

const rollbar = new Rollbar(rollbarConfig);
apiFlickClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestData = error.response.config.data;
    const requestError = error.response.data.errors.map(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (currentError: any) => currentError.detail,
    );
    rollbar.error(requestError, error, JSON.stringify(requestData));
  },
);

export const contentfulFlickClient = axios.create({
  baseURL: `https://graphql.contentful.com`,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN}`,
  },
});

export const contentfulApi = contentful.createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
});
